<template>
  <BaseCard flat>
    <BaseCardBody>
      <h3 class="text-sm">Google Ads: User List</h3>
      <p class="text-xs text-gray-500">
        {{ gaUserList.name }}
      </p>
      <p class="text-xs text-gray-500 mt-1">Customer: {{ customerName }}</p>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
export default {
  props: {
    gaUserList: {
      type: Object,
      required: true,
    },
  },
  computed: {
    customerName() {
      return this.gaUserList?.ga_customer?.name || 'N/A';
    },
  },
};
</script>
